// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ltklHBey6NAdFakh {
  margin-left: 12px;
  background-color: #4d87be;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  width: fit-content;
  padding: 0 15px;
  height: 35px;
  border-radius: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Bu4tqZqRnZYa48Vy {
  max-width: 1310px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.Bu4tqZqRnZYa48Vy h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.xgxc_mi4DIkuMN_r {
  margin-right: 0 !important;
}

.hiwgnrQ3SNEDiEUN {
  margin-top: 20px;
  width: 450px;
  height: 58px;
  padding: 12px 10px;
  border-radius: 16px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
  background: #ffffff;
}

.wYlireiiQd8h1Xjx {
  margin: 29px 0 30px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
}

.b6rciBaC7EWgunq6 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.ES3NmqkK99sAlRDJ {
  display: flex;
  align-items: center;
}

.Bu4tqZqRnZYa48Vy .p-datatable-table {
  border-radius: 16px;
  overflow: hidden;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th {
  background-color: #f2e1bc;
  border: 1px solid #f3f5f7;
  padding: 18px 30px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th:first-child > div {
  display: flex;
  justify-content: flex-start;
}

.Bu4tqZqRnZYa48Vy .p-datatable-thead th > div {
  display: flex;
  justify-content: center;
  color: #303030;
  font-size: 18px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
  padding: 9px 8px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td:first-child {
  text-align: left;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
  text-align: center;
}

td:hover .tAsG4ArJCUcR28sl {
  background-color: #e1e7ed;
}

.tAsG4ArJCUcR28sl {
  padding: 28px 22px;
  border-radius: 6px;
}

.CYHs3RBbuTEDtiYR {
  width: 114px;
  height: 67px;
  border-radius: 6px;
}

.Bu4tqZqRnZYa48Vy .p-datatable-tbody td:hover .CYHs3RBbuTEDtiYR {
  background-color: #e1e7ed;
}

.E7189gkaO_4mqojn {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.xzej2dn7Go1WAi2J,
.J9Et5Af6yrs9MUHw,
.Ej0zrMPNEq0M942M {
  width: 75px;
  height: 67px;
}

.xzej2dn7Go1WAi2J:hover {
  background-color: #c5f3c1;
}

.J9Et5Af6yrs9MUHw:hover {
  background-color: #e1e7ed;
}

.Ej0zrMPNEq0M942M:hover {
  background-color: #ffcaca;
}

.xzej2dn7Go1WAi2J span::before {
  color: #56be4d;
  font-size: 20px;
}

.Ej0zrMPNEq0M942M span::before {
  color: #dd0000;
  font-size: 20px;
}

.xzej2dn7Go1WAi2J:hover span::before {
  color: #185625;
}

.J9Et5Af6yrs9MUHw:hover span::before {
  color: #20336c;
}

.J9Et5Af6yrs9MUHw span::before {
  color: #4d87be;
  font-size: 20px;
}

.z0_cYvS6lIEwMDlW {
  color: #000000;
  background-color: transparent;
  border: none;
}

.z0_cYvS6lIEwMDlW i {
  font-size: 16px;
  background-color: #f2e1bc;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.sU8IcNXAJ8OYd_gy {
  width: 100%;
  background-color: #dd0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.sU8IcNXAJ8OYd_gy:hover {
  background-color: #721010;
}

.oh0xqp_powRkVybG {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.oh0xqp_powRkVybG:hover {
  color: #305375;
}

.aCKiBqYnsC7SVALi {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.aCKiBqYnsC7SVALi .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.aCKiBqYnsC7SVALi .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.aCKiBqYnsC7SVALi .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.aCKiBqYnsC7SVALi .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.aCKiBqYnsC7SVALi .hbdNZCCnedodrX8B {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.aCKiBqYnsC7SVALi .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.aCKiBqYnsC7SVALi .p-dialog-content {
  background-color: #f3f5f7;
}

.xgxc_mi4DIkuMN_r {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.xgxc_mi4DIkuMN_r:hover {
  background-color: #185625;
}

.PMuH6KDWezkNqrje {
  width: 674px !important;
  height: fit-content;
  background-color: #f3f5f7;
  border-radius: 16px !important;
}

.PMuH6KDWezkNqrje .p-dialog {
  border-radius: 16px !important;
}

.PMuH6KDWezkNqrje .p-dialog-footer {
  border-bottom-right-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.PMuH6KDWezkNqrje .p-dialog-header {
  border-top-right-radius: 16px !important;
  border-top-left-radius: 16px !important;
  background-color: #f3f5f7;
}

.PMuH6KDWezkNqrje .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.PMuH6KDWezkNqrje .p-dialog-content {
  background-color: #f3f5f7;
}

.PMuH6KDWezkNqrje .field label {
  font-size: 20px !important;
  font-weight: 400 !important;
}

.yNPlFgtbFAp0cAnh {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.PnDnG2lJlBYaHyvk .p-icon-field {
  width: 100%;
}

.PnDnG2lJlBYaHyvk input {
  width: 100%;
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 44px 14px 20px;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.PnDnG2lJlBYaHyvk span {
  right: 1.5rem;
}

.ougPFFb_2Yzmu1TS {
  border-radius: 16px 0 0 16px !important;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.v63Y1uFiqCMACvep {
  border-radius: 0 16px 16px 0 !important;
  background-color: #ffffff;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.GtHE_wxoCwsn8axP {
  width: 100%;
  height: 90px;
}

.GtHE_wxoCwsn8axP .p-dropdown-trigger {
  margin-right: 10px;
}

.GtHE_wxoCwsn8axP .p-dropdown {
  width: 100% !important;
  text-align: left;
  border-radius: 16px;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
  border: none;
}

.GtHE_wxoCwsn8axP .p-dropdown-label {
  display: block;
  padding: 14px 20px;
  font-size: 18px;
  font-family: "Roboto";
}

.fd4VjhwCI7ov0M7J {
  border-radius: 24px;
  border: 1px solid #a4a4a4;
  overflow: hidden;
  padding: 16px 20px;
}

.fd4VjhwCI7ov0M7J .p-dropdown-items-wrapper {
  max-height: 400px !important;
}

.fd4VjhwCI7ov0M7J .p-dropdown-items li {
  height: 40px;
  border-radius: 15px;
  margin: 4px 0;
  font-size: 18px;
  color: #303030;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  border: 2px solid transparent;
}

.fd4VjhwCI7ov0M7J
  .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  border: 2px solid #20336c;
  background-color: inherit;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
  background-color: inherit;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item.p-highlight {
  color: #ffffff;
  background-color: #20336c;
}

.fd4VjhwCI7ov0M7J .p-dropdown-item.p-highlight:after {
  content: "✓";
  position: absolute;
  right: 16px;
  font-size: 24px;
  color: #ffffff;
}

.myPk0GZg8Ikrn068 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qGf5mTExSwMEqko3 {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Ork80uLUufc5FYWC {
  display: flex;
  flex-direction: column;
}

.IY85Q5ylU4XB0qoU {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
}

.ywTqO_ACn0hIvkOj {
  color: #888888;
  font-weight: 400;
  font-size: 12px;
  margin-left: 3px;
}

.rwXfzxeQfksifllX {
  display: flex;
  gap: 10px;
}

.rwXfzxeQfksifllX button {
  cursor: pointer;
}

.cpWja8F5BbQIN_BJ {
  color: #1976d2;
  background: none;
  border: none;
}

.FGrJJ33DXIMcY8KI {
  color: #d32f2f;
  background: none;
  border: none;
  font-size: 20px;
}

.cpWja8F5BbQIN_BJ i::before,
.FGrJJ33DXIMcY8KI i::before {
  font-size: 20px;
}

@media screen and (min-width: 1166px) and (max-width: 1360px) {
  .xzej2dn7Go1WAi2J,
  .J9Et5Af6yrs9MUHw,
  .Ej0zrMPNEq0M942M,
  .CYHs3RBbuTEDtiYR {
    width: 45px;
    height: 37px;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-thead tr th div {
    font-size: 13px !important;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
    font-size: 13px !important;
  }
}

@media screen and (min-width: 1105px) and (max-width: 1165px) {
  .xzej2dn7Go1WAi2J,
  .J9Et5Af6yrs9MUHw,
  .Ej0zrMPNEq0M942M,
  .CYHs3RBbuTEDtiYR {
    width: 40px;
    height: 32px;
  }

  .xzej2dn7Go1WAi2J span::before,
  .J9Et5Af6yrs9MUHw span::before,
  .Ej0zrMPNEq0M942M span::before,
  .CYHs3RBbuTEDtiYR span::before {
    font-size: 11px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Bu4tqZqRnZYa48Vy .p-datatable-thead tr th div {
    font-size: 11px !important;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
    font-size: 11px !important;
  }
}

@media screen and (min-width: 890px) and (max-width: 1045px) {
  .xzej2dn7Go1WAi2J,
  .J9Et5Af6yrs9MUHw,
  .Ej0zrMPNEq0M942M {
    width: 45px;
    height: 37px;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-thead tr th div {
    font-size: 13px !important;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
    font-size: 13px !important;
  }
}

@media screen and (min-width: 791px) and (max-width: 889px) {
  .xzej2dn7Go1WAi2J,
  .J9Et5Af6yrs9MUHw,
  .Ej0zrMPNEq0M942M,
  .CYHs3RBbuTEDtiYR {
    width: 40px;
    height: 32px;
  }

  .xzej2dn7Go1WAi2J span::before,
  .J9Et5Af6yrs9MUHw span::before,
  .Ej0zrMPNEq0M942M span::before,
  .CYHs3RBbuTEDtiYR span::before {
    font-size: 11px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Bu4tqZqRnZYa48Vy .p-datatable-thead tr th div {
    font-size: 11px !important;
  }
  .Bu4tqZqRnZYa48Vy .p-datatable-tbody tr td {
    font-size: 11px !important;
  }
}

@media screen and (max-width: 510px) {
  .wYlireiiQd8h1Xjx {
    margin: 45px 0 8px 0;
    flex-direction: column-reverse;
  }

  .wYlireiiQd8h1Xjx h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .ES3NmqkK99sAlRDJ {
    grid-area: title;
    margin: 0;
    order: +1;
  }

  .ltklHBey6NAdFakh {
    display: none;
  }

  .z0_cYvS6lIEwMDlW {
    padding: 0;
    margin-top: 12px;
    margin-bottom: 25px;
    width: 100%;
    grid-area: btn;
  }

  .z0_cYvS6lIEwMDlW span {
    display: none;
  }

  .z0_cYvS6lIEwMDlW i {
    font-size: 12px;
    background-color: #f2e1bc;
    padding: 10px;
    border-radius: 6px;
    margin-left: 0;
    width: 100%;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .aCKiBqYnsC7SVALi,
  .PMuH6KDWezkNqrje {
    width: 350px !important;
  }

  .PMuH6KDWezkNqrje .field label {
    font-size: 16px !important;
  }

  .aCKiBqYnsC7SVALi .p-dialog-title,
  .PMuH6KDWezkNqrje .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .aCKiBqYnsC7SVALi .hbdNZCCnedodrX8B {
    font-size: 16px;
  }

  .ougPFFb_2Yzmu1TS {
    font-size: 16px;
  }

  .xgxc_mi4DIkuMN_r {
    padding: 14px 0;
    font-size: 16px;
  }

  .sU8IcNXAJ8OYd_gy {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }

  .oh0xqp_powRkVybG {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .GtHE_wxoCwsn8axP .p-dropdown-label {
    font-size: 16px;
  }

  .hiwgnrQ3SNEDiEUN {
    width: 100%;
    height: 44px;
    margin: 0;
    padding: 5px 10px;
    border-radius: 16px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
    background: #ffffff;
    grid-area: dropdown;
    order: +1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/UserManagement.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC;;;iCAG+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB;;;iCAG+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB;;;iCAG+B;EAC/B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE;;;;IAIE,WAAW;IACX,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;IAIE,WAAW;IACX,YAAY;EACd;;EAEA;;;;IAIE,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,WAAW;IACX,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;IAIE,WAAW;IACX,YAAY;EACd;;EAEA;;;;IAIE,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".organizationLabel {\r\n  margin-left: 12px;\r\n  background-color: #4d87be;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  width: fit-content;\r\n  padding: 0 15px;\r\n  height: 35px;\r\n  border-radius: 200px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.pageWrapper {\r\n  max-width: 1310px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.saveBtn {\r\n  margin-right: 0 !important;\r\n}\r\n\r\n.dropdown {\r\n  margin-top: 20px;\r\n  width: 450px;\r\n  height: 58px;\r\n  padding: 12px 10px;\r\n  border-radius: 16px;\r\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n  background: #ffffff;\r\n}\r\n\r\n.header {\r\n  margin: 29px 0 30px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 18px;\r\n}\r\n\r\n.titleRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.headerTitle {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n  background-color: #f2e1bc;\r\n  border: 1px solid #f3f5f7;\r\n  padding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #303030;\r\n  font-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n  border: 1px solid #f3f5f7;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n  text-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n  text-align: center;\r\n}\r\n\r\n:global(td:hover) .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n  padding: 28px 22px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 114px;\r\n  height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td:hover) .activeBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cellSoundWrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn {\r\n  width: 75px;\r\n  height: 67px;\r\n}\r\n\r\n.playBtn:hover {\r\n  background-color: #c5f3c1;\r\n}\r\n\r\n.soundBtn:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.deleteBtn:hover {\r\n  background-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n  color: #56be4d;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.playBtn:hover span::before {\r\n  color: #185625;\r\n}\r\n\r\n.soundBtn:hover span::before {\r\n  color: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.createBtn i {\r\n  font-size: 16px;\r\n  background-color: #f2e1bc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #dd0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.deleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.userModal {\r\n  width: 674px !important;\r\n  height: fit-content;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.userModal :global(.p-dialog) {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.userModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 16px !important;\r\n  border-bottom-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.userModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 16px !important;\r\n  border-top-left-radius: 16px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.userModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.userModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.userModal :global(.field) label {\r\n  font-size: 20px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.passwordInput :global(.p-icon-field) {\r\n  width: 100%;\r\n}\r\n\r\n.passwordInput input {\r\n  width: 100%;\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 44px 14px 20px;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.passwordInput span {\r\n  right: 1.5rem;\r\n}\r\n\r\n.phonePrefix {\r\n  border-radius: 16px 0 0 16px !important;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.inputPhone {\r\n  border-radius: 0 16px 16px 0 !important;\r\n  background-color: #ffffff;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.dropDownWrapper {\r\n  width: 100%;\r\n  height: 90px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-trigger) {\r\n  margin-right: 10px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n  width: 100% !important;\r\n  text-align: left;\r\n  border-radius: 16px;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n  border: none;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n  display: block;\r\n  padding: 14px 20px;\r\n  font-size: 18px;\r\n  font-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n  border-radius: 24px;\r\n  border: 1px solid #a4a4a4;\r\n  overflow: hidden;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n  max-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n  height: 40px;\r\n  border-radius: 15px;\r\n  margin: 4px 0;\r\n  font-size: 18px;\r\n  color: #303030;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel\r\n  :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n  border: 2px solid #20336c;\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n  background-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  right: 16px;\r\n  font-size: 24px;\r\n  color: #ffffff;\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n}\r\n\r\n.subfield {\r\n  color: #888888;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  margin-left: 3px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.actions button {\r\n  cursor: pointer;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 20px;\r\n}\r\n\r\n@media screen and (min-width: 1166px) and (max-width: 1360px) {\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn,\r\n  .activeBtn {\r\n    width: 45px;\r\n    height: 37px;\r\n  }\r\n  .pageWrapper :global(.p-datatable-thead tr th div) {\r\n    font-size: 13px !important;\r\n  }\r\n  .pageWrapper :global(.p-datatable-tbody tr td) {\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1105px) and (max-width: 1165px) {\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn,\r\n  .activeBtn {\r\n    width: 40px;\r\n    height: 32px;\r\n  }\r\n\r\n  .playBtn span::before,\r\n  .soundBtn span::before,\r\n  .deleteBtn span::before,\r\n  .activeBtn span::before {\r\n    font-size: 11px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-thead tr th div) {\r\n    font-size: 11px !important;\r\n  }\r\n  .pageWrapper :global(.p-datatable-tbody tr td) {\r\n    font-size: 11px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 890px) and (max-width: 1045px) {\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn {\r\n    width: 45px;\r\n    height: 37px;\r\n  }\r\n  .pageWrapper :global(.p-datatable-thead tr th div) {\r\n    font-size: 13px !important;\r\n  }\r\n  .pageWrapper :global(.p-datatable-tbody tr td) {\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 791px) and (max-width: 889px) {\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn,\r\n  .activeBtn {\r\n    width: 40px;\r\n    height: 32px;\r\n  }\r\n\r\n  .playBtn span::before,\r\n  .soundBtn span::before,\r\n  .deleteBtn span::before,\r\n  .activeBtn span::before {\r\n    font-size: 11px !important;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-thead tr th div) {\r\n    font-size: 11px !important;\r\n  }\r\n  .pageWrapper :global(.p-datatable-tbody tr td) {\r\n    font-size: 11px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 510px) {\r\n  .header {\r\n    margin: 45px 0 8px 0;\r\n    flex-direction: column-reverse;\r\n  }\r\n\r\n  .header h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .headerTitle {\r\n    grid-area: title;\r\n    margin: 0;\r\n    order: +1;\r\n  }\r\n\r\n  .organizationLabel {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn {\r\n    padding: 0;\r\n    margin-top: 12px;\r\n    margin-bottom: 25px;\r\n    width: 100%;\r\n    grid-area: btn;\r\n  }\r\n\r\n  .createBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn i {\r\n    font-size: 12px;\r\n    background-color: #f2e1bc;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    margin-left: 0;\r\n    width: 100%;\r\n    height: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .deleteModal,\r\n  .userModal {\r\n    width: 350px !important;\r\n  }\r\n\r\n  .userModal :global(.field) label {\r\n    font-size: 16px !important;\r\n  }\r\n\r\n  .deleteModal :global(.p-dialog-title),\r\n  .userModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n\r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .phonePrefix {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropDownWrapper :global(.p-dropdown-label) {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dropdown {\r\n    width: 100%;\r\n    height: 44px;\r\n    margin: 0;\r\n    padding: 5px 10px;\r\n    border-radius: 16px;\r\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);\r\n    background: #ffffff;\r\n    grid-area: dropdown;\r\n    order: +1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var organizationLabel = `ltklHBey6NAdFakh`;
export var pageWrapper = `Bu4tqZqRnZYa48Vy`;
export var saveBtn = `xgxc_mi4DIkuMN_r`;
export var dropdown = `hiwgnrQ3SNEDiEUN`;
export var header = `wYlireiiQd8h1Xjx`;
export var titleRow = `b6rciBaC7EWgunq6`;
export var headerTitle = `ES3NmqkK99sAlRDJ`;
export var cellInsider = `tAsG4ArJCUcR28sl`;
export var activeBtn = `CYHs3RBbuTEDtiYR`;
export var cellSoundWrapper = `E7189gkaO_4mqojn`;
export var playBtn = `xzej2dn7Go1WAi2J`;
export var soundBtn = `J9Et5Af6yrs9MUHw`;
export var deleteBtn = `Ej0zrMPNEq0M942M`;
export var createBtn = `z0_cYvS6lIEwMDlW`;
export var deleteDialogBtn = `sU8IcNXAJ8OYd_gy`;
export var cancelDialogBtn = `oh0xqp_powRkVybG`;
export var deleteModal = `aCKiBqYnsC7SVALi`;
export var text = `hbdNZCCnedodrX8B`;
export var userModal = `PMuH6KDWezkNqrje`;
export var input = `yNPlFgtbFAp0cAnh`;
export var passwordInput = `PnDnG2lJlBYaHyvk`;
export var phonePrefix = `ougPFFb_2Yzmu1TS`;
export var inputPhone = `v63Y1uFiqCMACvep`;
export var dropDownWrapper = `GtHE_wxoCwsn8axP`;
export var dropDownPanel = `fd4VjhwCI7ov0M7J`;
export var cardList = `myPk0GZg8Ikrn068`;
export var cardItem = `qGf5mTExSwMEqko3`;
export var cardInfo = `Ork80uLUufc5FYWC`;
export var name = `IY85Q5ylU4XB0qoU`;
export var subfield = `ywTqO_ACn0hIvkOj`;
export var actions = `rwXfzxeQfksifllX`;
export var cardEditBtn = `cpWja8F5BbQIN_BJ`;
export var cardDeleteBtn = `FGrJJ33DXIMcY8KI`;
export default ___CSS_LOADER_EXPORT___;
